exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blinking{\n    animation:blinkingText 1.2s infinite;\n}\n@keyframes blinkingText{\n0%{     color: #FF0000;\n}\n49%{    color: #000;\n}\n60%{    color: transparent;\n}\n99%{    color:transparent;\n}\n100%{   color: #000;\n}\n}\n", ""]);

// exports
